var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFfFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.991211 4H26.9548L25.5124 6H0.991211V4Z",
    fill: "#1D2A45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.991211 13H25.5124L26.9548 11H0.991211V13Z",
    fill: "#1D2A45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.991211 20H25.5124L26.9548 18H0.991211V20Z",
    fill: "#1D2A45"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.48227,
    cy: 5,
    rx: 3.24545,
    ry: 3,
    fill: "#1D2A45"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.3822,
    cy: 12,
    rx: 3.24545,
    ry: 3,
    fill: "#1D2A45"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.8914,
    cy: 19,
    rx: 3.24545,
    ry: 3,
    fill: "#1D2A45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfFilter);
export default __webpack_public_path__ + "static/media/ff-filter.48472d8f3f35cfea80470a8954bb34b5.svg";
export { ForwardRef as ReactComponent };